import { Quote } from "lucide-react";
import { Card } from "@/components/ui/card";

/**
 * Trust / social-proof section.
 *
 * It deliberately contains NO invented logos, quotes or statistics. Every item
 * is an obvious placeholder to be replaced with real, permissioned content.
 */
export function SocialProof() {
  return (
    <section
      className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-24"
      aria-labelledby="trust-heading"
    >
      <div className="mx-auto mb-10 max-w-2xl text-center" data-reveal>
        <h2 id="trust-heading" className="text-3xl font-bold tracking-tight lg:text-4xl">
          Built with teachers, for their classrooms
        </h2>
        <p className="mt-3 text-muted">
          We are growing with schools as we go. Real references and reviews will appear here once we
          have permission to share them.
        </p>
      </div>

      <ul
        className="mx-auto grid max-w-4xl grid-cols-2 gap-4 sm:grid-cols-4"
        aria-label="School logos (placeholders)"
        data-reveal
      >
        {[1, 2, 3, 4].map((n) => (
          <li
            key={n}
            className="grid h-20 place-items-center rounded-xl border border-dashed border-border bg-surface/60 px-2 text-center text-[11px] font-medium uppercase tracking-widest text-muted"
          >
            [School logo {n}]
          </li>
        ))}
      </ul>

      <Card
        className="mx-auto mt-8 max-w-3xl rounded-2xl border-2 bg-surface/80 p-8 text-center backdrop-blur-sm"
        data-reveal
        data-reveal-delay="0.05"
      >
        <Quote className="mx-auto size-8 text-accent" aria-hidden="true" />
        <blockquote className="mt-4 text-lg leading-relaxed text-text">
          &ldquo;[Teacher testimonial placeholder &mdash; add a real quote here once a teacher has
          agreed to be named.]&rdquo;
        </blockquote>
        <p className="mt-4 text-sm text-muted">[Teacher name, School]</p>
      </Card>
    </section>
  );
}
